export const SCROLL_TO = 'SCROLL_TO';

export const scrollTo = element => ({
  type: SCROLL_TO,
  element
});
